import { Pipe, PipeTransform } from '@angular/core';
import { Channel } from '../dto';

export class MessagePreview {
    public BodyPreview: string;
    public DateSent: Date;
    public SenderUsername: string;
}

@Pipe({
    name: 'messagePreview',
    standalone: false
})
export class MessagePreviewPipe implements PipeTransform {
    transform(channel: Channel): MessagePreview {
        if (channel.Messages.length === 0) {
            return null;
        } else {
            const message = channel.Messages[0];
            let preview = '';
            const text = message.DisplayText;
            if (text) {
                // The moderation text is shown whole - a mid-sentence cut would break its brackets.
                preview = message.IsModerated ? text : text.substring(0, Math.min(40, text.length));
            };

            return {
                BodyPreview: preview,
                DateSent: message.SendDate,
                SenderUsername: channel.Usernames.find(x => x === message.SenderUsername)
            };
        }
    }
}
